/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Deleted1Inputs */

const vi_guidevideo_deleted1 = /** @type {(inputs: Guidevideo_Deleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xoá video hướng dẫn.`)
};

/**

* @param {Guidevideo_Deleted1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_deleted1 = /** @type {((inputs?: Guidevideo_Deleted1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Deleted1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_deleted1(inputs)
});
export { guidevideo_deleted1 as "guideVideo_deleted" }